import { FC } from 'react';

interface Props {
  name: string;
  logoImage?: string;
  primaryColor?: string;
}

const QuizGroupHeader: FC<Props> = ({ name, logoImage, primaryColor }) => (
  <div className="flex flex-col items-center px-4 pt-6 pb-3 gap-1">
    {logoImage && (
      <img src={logoImage} alt={name} className="h-10 object-contain mb-1" />
    )}
    <h1
      className="text-xl font-extrabold text-center tracking-tight"
      style={{ color: primaryColor || '#fff' }}
    >
      {name}
    </h1>
  </div>
);

export default QuizGroupHeader;
